import {ChevronDownIcon, ChevronUpIcon} from '@sanity/icons'
import {Box, Flex, Label, Text} from '@sanity/ui'
import React from 'react'

const sortStates = {
  asc: {
    icon: <ChevronUpIcon />,
    label: 'Sorted ascending',
  },
  desc: {
    icon: <ChevronDownIcon />,
    label: 'Sorted descending',
  },
  none: {
    icon: null,
    label: '',
  },
}

interface SortableHeaderProps {
  label: string
  sortDirection: 'asc' | 'desc' | 'none'
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  headerSuffix?: React.ReactNode
}

export function SortableHeader({label, sortDirection, onClick, headerSuffix}: SortableHeaderProps) {
  const sortState = sortStates[sortDirection] || sortStates.none

  return (
    <Flex
      align="center"
      gap={2}
      justify="space-between"
      onClick={onClick}
      style={{cursor: 'pointer'}}
    >
      <Box>
        <Label align="left" textOverflow="ellipsis">
          {label}
        </Label>
      </Box>
      {headerSuffix}
      {sortState.icon && (
        <Text size={1} aria-label={sortState.label}>
          {sortState.icon}
        </Text>
      )}
    </Flex>
  )
}
